/**
 * region_home1b(2026-10-18 · instr/cl/region_home1b) — 홈 히어로 «대표 현장» 캐러셀(라이브러리 0 · 'use client' 없음 —
 *   서버 컴포넌트로도, region-a 의 클라이언트 섬(HomeRegionHero)에서도 그대로 쓴다. 훅 0).
 *
 *   · 카드 HTML 은 전부 최초 응답(SSR)에 — 숨은 슬라이드도 DOM 에 실제 <a href>(크롤러·사용자 같은 HTML · UA 분기 0).
 *   · JS 없이도 가로 스크롤(scroll-snap)로 다 보인다. 클라이언트 부품은 공용 CarouselNav(상세 card_carousel1 과 같은 부품)뿐.
 *   · 자동 넘김 없음(타이머 0). 첫 장만 loading=eager(LCP = 종전 단일 히어로 이미지 그대로) · 나머지 lazy.
 *   · 모바일: 스와이프 + 다음 카드 24px 보이기 · 데스크톱: 좌우 화살표 · 점(위치). 카드 내용은 종전 히어로 그대로(FeatureCard 공용).
 *   · 1장이면 종전 단일 카드 마크업 그대로(래퍼 0).
 *   · 루트 #clh-hero 는 data-cc-rail 로 안의 레일을 찾는다 — 섬이 지역 배열로 슬라이드를 갈아 끼워도 점·화살표가 따라간다.
 *   · data-kd-hr-dep — region-a 첫 화면 가림(지역 확정 전 visibility:hidden · 자리 유지) 대상 표식.
 */
import { FeatureCard, slideAttrs, type HeroFeature } from '@/components/ds2';
import CarouselNav from '@/components/apt/detail/carousel/CarouselNav';
import { HERO_CAROUSEL_MAX, heroFeatureOf, type HeroCard } from './types';
import './home-carousel.css';

export const HERO_RAIL_ID = 'clh-hero';

/** 슬라이드 원천 = ds2 HeroFeature 배열(region-a HeroCard → heroFeatureOf 결과를 그대로 받는다). */
export function HeroFeatureCarousel({ features, label = '대표 현장' }: { features: readonly HeroFeature[]; label?: string }) {
  const seen = new Set<string>();
  const list = features
    .filter((f) => {
      const k = String(f?.href || f?.title || '').trim();
      if (!k || !String(f.title ?? '').trim() || seen.has(k)) return false;
      seen.add(k);
      return true;
    })
    .slice(0, HERO_CAROUSEL_MAX);
  const n = list.length;
  if (!n) return null;
  if (n === 1) return <FeatureCard feature={list[0]} />;
  return (
    <div
      className="clh-hc" id={HERO_RAIL_ID} data-cc-rail=".clh-hc__rail" role="region" aria-roledescription="carousel" aria-label={label}
      data-home-carousel="hero" data-kd-hr-dep=""
    >
      <div className="clh-hc__rail">
        {list.map((f, i) => (
          <div key={String(f.href || f.title)} className="clh-hc__slide" role="group" {...slideAttrs(i, n)}>
            <FeatureCard feature={f} loading={i === 0 ? 'eager' : 'lazy'} />
          </div>
        ))}
      </div>
      <CarouselNav railId={HERO_RAIL_ID} total={n} label={label} dots pos={false} focusScroll track="home_hero" />
    </div>
  );
}

/** 전국(지역 미선택) 서버 경로 — HeroCard(= HeroPick 모양) 배열. */
export default function HomeHeroCarousel({ cards, label }: { cards: readonly HeroCard[]; label?: string }) {
  return <HeroFeatureCarousel features={cards.map(heroFeatureOf)} label={label} />;
}
